import moment, { Moment }    from 'moment';
import { reactLocalStorage } from 'reactjs-localstorage';
import { EnvironmentObject } from '../environments/types/base';
import { TimeService }       from '../services';

//@ts-ignore
let environment: EnvironmentObject = __ENV__;

interface UseLastActivityTimestampHook {
	getLastActivityTimestamp: () => null | Moment,
	setLastActivityTimestamp: () => string,
	clearLastActivityTimestamp: () => void,
}

const useLastActivityTimestamp = (): UseLastActivityTimestampHook => {

	// Retrieves storage name from environment
	const getPrefsStorageKeyName = (): string => {
		return environment.session.cookies.lastActivity.namedKey
	}

	// Retrieves timestamp moment value
	const getLastActivityTimestamp: UseLastActivityTimestampHook['getLastActivityTimestamp'] = () => {

		let timestampValue = reactLocalStorage.get( getPrefsStorageKeyName(), null ),
		    timestamp      = TimeService.ISOtoMoment( timestampValue );

		return timestamp.isValid() ? timestamp : null;
	}

	// Sets timestamp moment value
	const setLastActivityTimestamp: UseLastActivityTimestampHook['setLastActivityTimestamp'] = () => {

		return reactLocalStorage.set( getPrefsStorageKeyName(), TimeService.momentToISO( moment() ) );
	}

	// Sets timestamp to nothing
	const clearLastActivityTimestamp: UseLastActivityTimestampHook['setLastActivityTimestamp'] = () => {

		return reactLocalStorage.remove( getPrefsStorageKeyName() );
	}

	return {
		getLastActivityTimestamp,
		setLastActivityTimestamp,
		clearLastActivityTimestamp
	};
}

export { useLastActivityTimestamp }
